'use client';

import classNames from 'classnames';

import { ArticleCard } from '~components/ArticleCard/ArticleCard';
import { ScrollContainer } from '~components/ScrollContainer/ScrollContainer';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';
import { Section3CardsProps } from '~containers/MainPage/Section3Cards/Section3Cards.types';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { ArticleCardImagePosition } from '~types/Article.types';

import styles from './Section3Cards.module.scss';

const ARTICLES_COUNT = 3;

export function Section3Cards({
  title,
  titleBacklight,
  category,
  articles,
  ...sectionProps
}: Section3CardsProps) {
  const [, { isDesktop }] = useBreakpoints();

  if (!articles.length) return null;

  const featuredArticles = articles.slice(0, ARTICLES_COUNT);
  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          href={category.href}
          countArticles={category.count}
          hasPageCategory={!!category.href}
        />
      )}
      <ScrollContainer active={!isDesktop}>
        <div className={classNames(styles.articles)}>
          {featuredArticles.map((article, key) => (
            <ArticleCard
              key={article.id}
              className={styles.article}
              imagePosition={
                key === 1
                  ? ArticleCardImagePosition.Bottom
                  : ArticleCardImagePosition.Top
              }
              {...article}
              categories={[category]}
            />
          ))}
        </div>
      </ScrollContainer>
    </Section>
  );
}
